import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';

class ContributionSlRows extends Component{
    constructor(props){
        super(props)
        this.state = {
            loading: true,
            usrMemberSetId: null
        }
    }

    static getDeriveStateFromProps(props, state){
        return {
            usrMemberSetId: props.match.params.usrMemberSetId
        }
    }

    // makeColumns(){
    //     this.props.futureStrategy.
    // }

    render(){
        const {t} = this.props
        const frequency = this.props.memberContribution.frequency
        return(
            <div style={{marginTop:"-10px", marginLeft: "10px", fontSize: "12px"}}>
                <p>{t("contribution:levels:part1")}<b>{t("contribution:levels:part2", {frequency})}</b>{t("contribution:levels:part3")}</p>
                
                <table className="table-responsive superlifeLegacyPlan" style={{marginLeft: "10px", marginRight: "1px"}}>
                    <thead  style={{textAlign: "left"}}>
                        <tr>
                            <th></th>
                            <th colSpan={6}>{t("contribution:dollarAmount", {frequency})}</th>
                        </tr>
                        <tr>
                            <th></th>
                            <th colSpan={2}>{t("contribution:memberAmount")}</th>
                            <th colSpan={3}>{t("contribution:employerAmount")}</th>
                            <th>{t("contribution:totalAmount")}</th>
                        </tr>
                        
                    </thead>
                    <tbody>
                        {this.props.memberContribution.contributionSlRows.map(contribution => 
                            
                            <tr>
                                {contribution.type =='H' ? 
                                    contribution.savings ?<td style={{textAlign: "left"}}><b>{t("contribution:header:savings")}</b></td>:
                                        contribution.insurance ? <td style={{textAlign: "left"}}><b>{t("contribution:header:insurance")}</b></td>:<td><b>{t("contribution:header:other")}</b></td>
                                    :<></>
                                }


                                {contribution.type == 'H' && contribution.savings? <td colSpan={2}></td>:<></>}

                                {contribution.type == 'H' && contribution.savings && this.props.memberContribution.empSavingsType == 'BOTH' ?
                                    <>
                                    <td>{t("contribution:gross")}</td>
                                    <td>{t("contribution:net")}</td>
                                    <td>{t("contribution:net")}</td>
                                    </>
                                    :<></>
                                }

                                {contribution.type == 'H' && contribution.savings && this.props.memberContribution.empSavingsType == 'PERCENT' ?
                                    <>
                                    <td>{t("contribution:gross")}</td>
                                    <td colSpan={2}>{t("contribution:net")}</td>
                                    </>
                                    :<></>
                                }

                                {contribution.type == 'H' && contribution.savings  && this.props.memberContribution.empSavingsType == 'AMOUNT'? 
                                    <td colSpan={3}>{t("contribution:net")}</td>:<></>
                                }


                                {contribution.type == 'H' && contribution.savings  && this.props.memberContribution.empSavingsType == 'NEITHER'? 
                                    <td colSpan={3}></td>:<></>
                                }


                                {contribution.type == 'H' && contribution.savings? <td></td>:<></>}
                                

                                {contribution.type == 'H' && !contribution.savings? 
                                    <>
                                        <td colSpan={2}>{contribution.dispMemberAmount}</td>
                                        <td colSpan={3}>{contribution.dispEmployerAmount}</td>
                                        <td>{contribution.dispTotalAmount}</td>
                                    </>
                                    :<></>
                                }

                                {contribution.type == 'L' ?
                                    <>
                                    {!contribution.standard ? 
                                    <>
                                        <td  style={{textAlign: "left"}}>
                                            {contribution.savings? <span>{contribution.payerDesc}</span>:<span>{contribution.planDesc}</span>}
                                            
                                            {contribution.spouse? <span>{t("contribution:spouse")}</span>:<></>}
                                        </td>
                                        
                                        {contribution.savings ?
                                            <>
                                            {this.props.memberContribution.mbrSavingType =='BOTH'?
                                                <>
                                                    <td>{contribution.dispMemberAmount}</td>
                                                    <td>{contribution.dispMemberPercentage}</td>
                                                    <td>{contribution.dispEmployerPercentage}</td>
                                                    <td>{contribution.dispNetEmployerPercentage}</td>
                                                    <td>{contribution.dispEmployerAmount}</td>
                                                </>:<></>
                                            }

                                            {this.props.memberContribution.mbrSavingType =='PERCENT'?
                                                <>
                                                    <td colSpan={2}>{contribution.dispMemberPercentage}</td>
                                                    <td>{contribution.dispEmployerPercentage}</td>
                                                    <td colSpan={2}>{contribution.dispNetEmployerPercentage}</td>
                                                </>
                                                :<></>
                                            }

                                            {(this.props.memberContribution.mbrSavingType =='AMOUNT' || this.props.memberContribution.mbrSavingType =='NEITHER')?
                                                <>
                                                    <td colSpan={2}>{contribution.dispMemberAmount}</td>
                                                    <td colSpan={3}>{contribution.dispEmployerAmount}</td>
                                                </>:<></>
                                            }
                                            </>:
                                            <>
                                                <td colSpan={2}>{contribution.dispMemberAmount}</td>
                                                <td colSpan={3}>{contribution.dispEmployerAmount}</td>
                                            </>
                                        }
                                        
                                        <td>{contribution.dispTotalAmount}</td>
                                    </>
                                    : <>
                                        {contribution.standardSum?
                                        <>
                                            <td  style={{textAlign: "left"}}>
                                                <span>{t("contribution:standard")}</span>
                                                {contribution.spouse ? <span>{t("contribution:spouse")}</span> : <></>}
                                            </td>
                                            {this.props.memberContribution.mbrSavingsType=='BOTH'? 
                                                <>
                                                <td>{contribution.dispMemberPercentage}</td>
                                                <td>{contribution.dispMemberAmount}</td>
                                                <td>{contribution.dispEmployerPercentage}</td>
                                                <td>{contribution.dispNetEmployerPercentage}</td>
                                                <td>{contribution.dispEmployerAmount}</td>
                                                </>:<></>
                                            }

                                            {this.props.memberContribution.mbrSavingsType=='PERCENT'? 
                                                <>
                                                <td colSpan={2}>{contribution.dispMemberPercentage}</td>
                                                <td>{contribution.dispEmployerPercentage}</td>
                                                <td colSpan={2}>{contribution.dispNetEmployerPercentage}</td>
                                                </>:<></>
                                            }

                                            {(this.props.memberContribution.mbrSavingType =='AMOUNT' || this.props.memberContribution.mbrSavingType =='NEITHER')?
                                                <>
                                                <td colSpan={2}>{contribution.dispMemberAmount}</td>
                                                <td colSpan={3}>{contribution.dispEmployerAmount}</td>
                                                </>:<></>
                                            }

                                            <td>{contribution.dispTotalAmount}</td>
                                        </>
                                        :<></>
                                        }
                                    </>
                                    }</>:<></>
                                }

                                {contribution.type == 'T'?
                                    <>
                                        <td style={{textAlign: "left"}}><b>
                                            {contribution.savings? <span>{t("contribution:totals:savings")}</span>:
                                                <>
                                                {contribution.insurance ?
                                                    <span>{t("contribution:totals:insurance")}</span>:<span>{t("contribution:totals:other")}</span>
                                                }</>
                                            }
                                        </b></td>
                                        <td colSpan={2}><b>{contribution.dispMemberAmount}</b></td>
                                        <td colSpan={3}><b>{contribution.dispEmployerAmount}</b></td>
                                        <td><b>{contribution.dispTotalAmount}</b></td>
                                    </>:<></>
                                }

                                {contribution.type == 'F'?
                                    <>
                                        <td style={{textAlign: "left"}}>
                                        <b><span>{t("contribution:total")}</span></b>
                                        </td>
                                        <td colSpan={2}><b>{contribution.dispMemberAmount}</b></td>
                                        <td colSpan={3}><b>{contribution.dispEmployerAmount}</b></td>
                                        <td><b>{contribution.dispTotalAmount}</b></td>
                                    </>:<></>
                                }

                            </tr>
                        )}                        
                    </tbody>
                </table>

                
                
                {this.props.memberContribution.hasEmployerLevels ? <p>{t("contribution:employerlevels")}</p> : <></>}
                {/* {!this.props.memberContribution.ami ? 
                    <p>
                        {!this.props.memberContribution.hasVOLSavings ? 
                            <span>Contributions.changeLevel</span>:
                            <span>Contributions.changeLevel.hasVOL</span>
                        }
                    </p> 
                : <></>} */
                // TODO: Reconfirm if they should be allowed to change level from here
                }

                {this.props.memberContribution.hasMbrInsurances ? <p>{t("contribution:insurance:note")}</p> : <></>}
            </div>
        )
    }
}
export default withTranslation()(ContributionSlRows);